import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _class, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { List } from 'components';
import * as styles from './Dropdown.scss';
var Dropdown = (_temp = _class = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState({
        menuVisible: !_this.state.menuVisible
      });
    });

    _this.state = {
      menuVisible: false
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          wrapStyles = _this$props.wrapStyles,
          anchorOrigin = _this$props.anchorOrigin,
          items = _this$props.items,
          component = _this$props.component,
          menuStyles = _this$props.menuStyles;
      var bodyComponent = null;
      menuStyles.right = anchorOrigin.horizontal === 'left' ? wrapStyles.width : '0';
      menuStyles.top = anchorOrigin.vertical === 'top' ? '0' : wrapStyles.height;

      if (this.state.menuVisible) {
        if (items) {
          bodyComponent = /*#__PURE__*/React.createElement("div", {
            className: styles.list,
            style: menuStyles
          }, /*#__PURE__*/React.createElement(List, {
            items: items
          }));
        } else if (component) {
          bodyComponent = component;
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.menu,
        style: wrapStyles
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleMenu,
        className: styles.buttonWrap
      }, !this.props.openTrigger || !this.state.menuVisible ? trigger : this.props.openTrigger), /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        transitionName: "dropdown",
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      }, bodyComponent));
    }
  }]);

  return Dropdown;
}(Component), _defineProperty(_class, "propTypes", {
  trigger: PropTypes.object.isRequired,
  openTrigger: PropTypes.node,
  // the trigger component for when the Dropdown is open
  anchorOrigin: PropTypes.object,
  items: PropTypes.array,
  component: PropTypes.node,
  menuStyles: PropTypes.object
}), _defineProperty(_class, "defaultProps", {
  anchorOrigin: {
    horizontal: 'left',
    vertical: 'bottom'
  },
  menuStyles: {},
  wrapStyles: {}
}), _temp);
export default Dropdown;